var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 8.0625V14.4141L15.7891 12.1875C16 11.9531 16.3516 11.9531 16.5859 12.1875C16.7969 12.3984 16.7969 12.75 16.5859 12.9609L13.375 16.1484C13.1641 16.3828 12.8125 16.3828 12.6016 16.1484L9.41406 12.9609C9.17969 12.75 9.17969 12.3984 9.41406 12.1875C9.625 11.9531 9.97656 11.9531 10.2109 12.1875L12.4375 14.4141V8.0625C12.4375 7.75781 12.6719 7.5 13 7.5C13.3047 7.5 13.5625 7.75781 13.5625 8.0625ZM10 14.625L11.125 15.75H8.5C8.28906 15.75 8.125 15.9375 8.125 16.125V18C8.125 18.2109 8.28906 18.375 8.5 18.375H17.5C17.6875 18.375 17.875 18.2109 17.875 18V16.125C17.875 15.9375 17.6875 15.75 17.5 15.75H14.8516L15.9766 14.625H17.5C18.3203 14.625 19 15.3047 19 16.125V18C19 18.8438 18.3203 19.5 17.5 19.5H8.5C7.65625 19.5 7 18.8438 7 18V16.125C7 15.3047 7.65625 14.625 8.5 14.625H10ZM17.125 17.0625C17.125 17.3906 16.8672 17.625 16.5625 17.625C16.2344 17.625 16 17.3906 16 17.0625C16 16.7578 16.2344 16.5 16.5625 16.5C16.8672 16.5 17.125 16.7578 17.125 17.0625Z",
    fill: "#15161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.9e4778a3f8d6204c608a81f91cb1f40a.svg";
export { ForwardRef as ReactComponent };